module.exports = __webpack_public_path__ + "img/parceiro4.7ce9fc76.png";